import { render, staticRenderFns } from "./shadow.vue?vue&type=template&id=79b000e4&scoped=true&lang=pug&"
import script from "./shadow.vue?vue&type=script&lang=js&"
export * from "./shadow.vue?vue&type=script&lang=js&"
import style0 from "./shadow.vue?vue&type=style&index=0&id=79b000e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b000e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79b000e4', component.options)
    } else {
      api.reload('79b000e4', component.options)
    }
    module.hot.accept("./shadow.vue?vue&type=template&id=79b000e4&scoped=true&lang=pug&", function () {
      api.rerender('79b000e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/shadow.vue"
export default component.exports